<template>
  <a :href="micliveUrl + event.id + '/match/' + item.id" target="_blank" id="match">
    <div class="team">
      <img
        class="logo"
        :src="item.local_team.shield"
        style="border-radius: 3px; object-fit: contain;"
      />

      <div class="name">{{ item.local_team.name }}</div>
    </div>
    <div class="meta">
      <div class="competition">
        <!-- {{ categories[item.category].groups[item.group].rounds }} -->
        <span class="category">{{ item.category_name }}</span>
        <template v-if="item.group">
          <span class="group"
            >{{ $t("miclive.competition.group") }}
            {{ item.group_name }}</span
          >
          <span class="round">{{
            $t(
              item.round_name
            )
          }}</span>
        </template>
        <template v-else-if="item.phase">
          <span class="group">
            {{ $t(item.phase_name) }}
          </span>
          <span class="round">
            {{
              $t(
                item.round_name
              )
            }}
          </span>
        </template>
        <span class="name">{{ item.name }}</span>
      </div>
      <div class="date">{{ formatDate(item.date) }}</div>
      <div class="facility">
        {{
          item.facility_name
        }}
      </div>
      <div class="score">
        <div class="value">
          {{ item.local_team_goals ? item.local_team_goals : "-" }}

          <span v-if="item.local_team_p_goals != null" class="penalties">
            ({{ item.local_team_p_goals }})
          </span>
        </div>
        <div class="value">
          {{ item.away_team_goals ? item.away_team_goals : "-" }}

          <span v-if="item.away_team_p_goals != null" class="penalties">
            ({{ item.away_team_p_goals }})
          </span>
        </div>
      </div>
      <div class="status">{{ $t("miclive.match.status" + item.status) }}</div>
    </div>

    <div class="team">
      <img
        class="logo"
        :src="item.away_team.shield"
        style="border-radius: 3px; object-fit: contain;"
      />
      <div class="name">{{ item.away_team.name }}</div>
    </div>
  </a>
</template>

<script>
export default {
  name: "Match",
  props: {
    item: Object
  },
  data() {
    return {};
  },
  computed: {
    micliveUrl() {
      return process.env.VUE_APP_MICLIVE_URL;
    },
    event () {
      return this.$store.getters['getCurrentEvent']()
    },
  },
  methods: {
    load() {},
    formatDate(date) {
      return moment(date, "YYYY-MM-DD HH:mm").format("ddd DD/MM HH:mm");
    }
  },
  created() {
    this.load();
  }
};
</script>

<style lang="scss" scoped>
$font-title: AvantGarde-Bold;

* {
    font-size: 10px !important;
    line-height: 12px !important;
}
#app {
    background-color: #f5f5f5;
    margin: 0;
    padding: 0;
    height: 100%;
}
#match {
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #f5f5f5;
  padding: 5px;
  width: 100%;
  height: 110px;
  margin-bottom: 0px;
  display: flex;
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.1);
  align-items: center;
  text-decoration: none;
  color: #222;
  transition: all 0.3s;

  .team {
    width: 30%;
    text-align: center;
    .logo {
      width: 80%;
      max-width: 40px;
    }
    .name {
    //   font-family: $font-title;
      color: #222;
      font-size: 11px;
      margin-top: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-align: center;
    }
  }
  .meta {
    text-transform: uppercase;
    width: 40%;
    font-size: 10px;
    text-align: center;

    .competition {
        text-align: center !important;
      color: #182654 !important;
      font-size: 10px !important;
      .category {
        font-family: $font-title;
        &:after {
          content: "|";
        //   font-family: $font-text;
          margin: 0 2px;
        }
      }
      .group {
        font-family: $font-title;
        &:after {
          content: "|";
        //   font-family: $font-text;
          margin: 0 2px;
        }
      }
      .round {
        font-family: $font-title;
        &:after {
          content: "|";
        //   font-family: $font-text;
          margin: 0 2px;
        }
      }
      .name {
      }
    }
    .date {
        font-size: 12px !important;
        text-align: center !important;
        font-family: $font-title;
      color: #222;
      font-size: 12px;
    }
    .facility {
        text-align: center !important;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%;
      white-space: nowrap;
    }
    .status {
        text-align: center !important;
      margin-top: 10px;
      font-size: 9px !important;
    }
    .score {
        text-align: center !important;
      border-radius: 4px;
      background-color: #eee;
      display: flex;
      text-align: center;
      padding: 5px;
      width: 70%;
      margin: 4px auto;

      .value {
        text-align: center !important;
        width: 100%;
        // font-family: $font-black;
        font-size: 20px;

        .penalties {
          font-size: 12px;
        //   font-family: $font-text;
          font-weight: bold;
          display: inherit;
        }
      }
    }
  }
  &:hover {
    background-color: #edffff;
  }
}

.laptop {
  #match {
    // max-width: 300px;
  }
}
</style>
